import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeModeProvider, useThemeMode } from './ThemeContext';
import darkTheme from './darkTheme';
import lightTheme from './lightTheme';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

function ThemeResolver({ children }) {
  const { mode } = useThemeMode();
  const theme = mode === 'dark' ? darkTheme : lightTheme;

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}

export default function TrustXThemeProvider({ children }) {
  return (
    <ThemeModeProvider>
      <ThemeResolver>{children}</ThemeResolver>
    </ThemeModeProvider>
  );
}
